var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    _vm._g(
      _vm._b(
        {
          staticClass: "jade-icon-button",
          class: _vm.computedClass,
          attrs: {
            "aria-label": _vm.icon,
            type: _vm.type,
            disabled: _vm.disabled || _vm.loading,
          },
        },
        "button",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.loading
        ? _c("jade-spinner", {
            attrs: { color: "current-color", size: _vm.computedIconSize },
          })
        : _c("jade-icon", {
            attrs: {
              color: "current-color",
              use: _vm.icon,
              size: _vm.computedIconSize,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }